import React from 'react';
import { InstantView, LazyView } from '../../types/BlockWithViews';
import { FetchedContainer } from '../FetchContainer';
import { ViewContextProvider } from './ViewContext';
import { RefreshViewContextProvider } from './RefreshViewContext';

type View<Embedded> = InstantView<Embedded> | LazyView;
export function asFetchableView<Embedded>(Component: React.FC<Embedded>) {
  const ViewContainer = FetchedContainer<Embedded, View<Embedded>>;
  const FetchableView = function (props: View<Embedded> & { [key: string]: any }) {
    return (
      <ViewContainer {...props}>
        {({ embedded, refresh }) => (
          <ViewContextProvider {...props}>
            <RefreshViewContextProvider refreshView={refresh}>
              {/* complains about missing key. key attribute may cause Component to not rerender after fetch. */}
              {/* @ts-expect-error -- missing key attribute */}
              <Component {...embedded} />
            </RefreshViewContextProvider>
          </ViewContextProvider>
        )}
      </ViewContainer>
    );
  };
  FetchableView.displayName = `AsFetchable${Component.displayName || Component.name}View`;
  return FetchableView;
}
